export function getColumnClass(column) {
  if (column === "icon") {
    return "icon-column";
  } else if (column === "organisationNumber") {
    return "org-nr-column";
  } else if (column === "status") {
      return "status-column";
  } else if (column === "action") {
      return "status-action";
  } else if (column === "warning") {
      return "warning-column";
  }
}